import "./style.css";

export default function LogosFooter() {
  return (
    <div className="logos-footer">
      <img 
        src="/aliados visor incendios.png" 
        alt="Colaboradores" 
        className="logos-footer-image"
      />
    </div>
  );
}
